import React from 'react'

import { Box, useTokens, Typography, Alert, Number, Divider } from '@barracuda-internal/bds-core-v2'
import EmailInfo from 'components/pages/quarantineAction/EmailInfo'
import UserInfo from 'components/pages/quarantineAction/UserInfo'

const AllowActionContent: React.FC<{
  subject: string
  content: { header: string; subHeader: string }
  initial: string
  headerFrom: string
  user: string
  date: string
}> = ({ subject, content, initial, headerFrom, user, date }) => {
  const tokens = useTokens()

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 'fill',
          height: 'auto',
          gap: tokens.aliasesSpaceContainerSpacious
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: 'fill',
            height: 'auto',
            gap: tokens.aliasesSpaceContainerDefault
          }}
        >
          <Number
            label="1"
            bdsType="staticNeutral"
            bdsSize="input"
            sx={{ state: 'default', hover: 'false', showDivider: 'false' }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: 'auto',
              gap: tokens.aliasesSpaceContainerDefault
            }}
          >
            <Typography variant="h4" sx={{ textAlign: 'left' }}>
              We will release the following message from quarantine to your inbox.
            </Typography>
            <EmailInfo user={user} headerFrom={headerFrom} subject={subject} date={date} />
          </Box>
        </Box>
        <Box sx={{ height: tokens.aliasesSpaceContainerDefault }}>
          <Divider sx={{ flow: 'vertical', width: 'fill', height: 'auto' }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: 'fill',
            height: 'auto',
            gap: tokens.aliasesSpaceContainerDefault
          }}
        >
          <Number
            label="2"
            bdsType="staticNeutral"
            bdsSize="input"
            sx={{ state: 'default', hover: 'false', showDivider: 'false' }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: 'auto',
              gap: tokens.aliasesSpaceContainerDefault
            }}
          >
            <Typography variant="h4" sx={{ textAlign: 'left' }}>
              We will allow all future emails from this sender. Ensure that the sender is safe before confirming.
            </Typography>
            <UserInfo user={user} headerFrom={headerFrom} initial={initial} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: tokens.aliasesSpaceContainerDefault, marginBottom: tokens.aliasesSpaceContainerSpacious }}>
        <Alert bdsType="neutralWarning" bdsBoxShadowType="inline">
          This is not a recommended action. It is risky to add senders to your allow list.{' '}
        </Alert>
      </Box>
    </>
  )
}

export default AllowActionContent
